import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ variant = "dark", className = "" }) => {
  const textColor = variant === "light" ? "text-white" : "text-navy";
  const subColor = variant === "light" ? "text-gold" : "text-gold";
  return (
    <Link to="/" data-testid="logo-link" className={`flex items-center gap-3 group ${className}`}>
      <div className="relative">
        <img
          src="/logo.png"
          alt="Crawford Construction & Development Ltd. logo"
          className="h-12 w-12 object-contain rounded-full ring-2 ring-gold/70 bg-white transition-transform duration-300 group-hover:scale-105"
        />
      </div>
      <div className="leading-none hidden sm:block">
        <div className={`font-display font-bold text-lg tracking-tight ${textColor}`}>CRAWFORD</div>
        <div className={`text-[10px] tracking-[0.25em] font-semibold ${subColor}`}>CONSTRUCTION & DEV.</div>
      </div>
    </Link>
  );
};
